module.exports = __webpack_public_path__ + "static/media/Left AP Z2.0a53126f.png";